import React, { useEffect, useState } from "react";
import styles from "./meetinghighlights.module.scss";
import { URAvatarGroup } from "../../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../../shared/widgets/avatarGroup/statusDot";
import { LoginState } from "../../../../../models/model";
import store from "../../../../../context/store/store";
import { useSelector } from "react-redux";
import _ from "lodash";
import moment from 'moment';
import { searchHandler, searchMeetingHighlight } from "../../../../../base/callService/common";
import ContactLoader from "../../../../../styles/images/Lottie Animation.json";
import Lottie from "lottie-react";

type MeetingStartScreenState = {
  searchKey:string;
  highlights:any;
  autoHighlights:any;
};


export default function MeetingHighlights() {
    let {meetingHighlights,searchKey ,detailPage, momLoad, part_MOM } = store.getState().meetingReducer;
    let {  contactReducer }: any = useSelector((state: any) => state);

  const [getData, setData] = useState<MeetingStartScreenState>({
    searchKey:"",highlights:meetingHighlights,autoHighlights:meetingHighlights
  });

  
  useEffect(()=>{
    setData({...getData,searchKey:searchKey})
    search(searchKey);
    },[searchKey])

    useEffect(()=>{
      setData({...getData,highlights:meetingHighlights,autoHighlights:meetingHighlights})
      },[JSON.stringify(detailPage.uuid),meetingHighlights])

    const search = (data: any) => {
      if (data !== "") {   let filtered = _.filter(meetingHighlights, function (elem: any) {
            return elem.summary?.toLowerCase().includes(data.toLowerCase()) 
          });
          
          setData({ ...getData, autoHighlights: filtered,searchKey : data });
      }
      else {
        setData({ ...getData, autoHighlights: meetingHighlights,searchKey:"" });
      }
    }


    let len = Math.round((meetingHighlights?.length / 8)> 0 ? meetingHighlights?.length : 1);
    let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  return (
    <>
      
      <div className={styles.tabsubinnerconsecmain}>
          <div className={styles.summarydetailssec}>
            <div className={styles.summarydetailinnermiddle}>
              <div className={styles.middlemainconsec}>
                {getData.autoHighlights && getData.autoHighlights.map((elem: any, i: any) => {
                  let searchh: any = searchMeetingHighlight(elem, getData.searchKey);
                  return (

                    <div className={styles.profilelists} key={i} id='transs'>
                      <div>
                        <URAvatarGroup className={`lefts size32 colorBG${random_color[i]}`}
                          profileInfo={<><span>{elem.name.toUpperCase().charAt(0)}</span><URStatusDot className='stsDotsm green' /></>} />
                      </div>
                      <div className={styles.middle}>
                        <h4>{elem.name}<span><span>{moment(elem.time).format("hh:mm A")}</span></span></h4>
                        {(searchh?.middleMsg !== "" && getData.searchKey !== "") ?
                          <p>{searchh?.firstMsg}
                            < span className={'highlight1'}>{searchh?.middleMsg}</span>{searchh?.lastMsg}</p> : (searchKey !== "" && searchh?.middleMsg === "") ?
                            <p>{elem.summary}</p> : <><p>{elem.summary}</p></>}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          {
            (part_MOM?.length === 0) && !momLoad && <div className={styles.middlemainconsec}>
              <h4></h4>
              <p className={styles.nodatafound}>No Data Found</p>
            </div>
          }
          {
            part_MOM?.length === 0 && momLoad &&
            <div ><Lottie className="svgLoadinglistcenter" animationData={ContactLoader} /></div>
          }
      </div>
  
    </>
  );
};

